import React, {useContext , useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import GroupIcon from '@material-ui/icons/Group';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import List from '@material-ui/core/List';
import { withRouter } from "react-router";
import {Divider, IconButton, MenuItem} from "@material-ui/core";
import {Menu} from "@mui/material";
import {AccountCircle} from "@material-ui/icons";
import Avatar from "@material-ui/core/Avatar";
import {AuthContext} from '../../../context/auth'
import {useLocation} from "react-router-dom";


const useStyles = makeStyles((theme) => ({
    nested: {
        paddingLeft: theme.spacing(4),
    },
}));


const MainList = (props) => {

    const {history, path, logoutAction, isDrawerOpen} = props;
    const location = useLocation();
    const anchorRefUserMenu = React.useRef(null);
    const [openUserMenu, setOpenUserMenu] = React.useState(false);
    const [productsMenuOpen, setProductsMenuOpen] = useState(true);
    const { authUser } = useContext(AuthContext);

    const handleUserMenuClose = (event) => {
        if (anchorRefUserMenu.current && anchorRefUserMenu.current.contains(event.target)) {
            return;
        }

        setOpenUserMenu(false);
    };
    const handleUserMenuToggle = () => {
        setOpenUserMenu((prevOpen) => !prevOpen);
    };

    return (
        <div style={{display: 'flex', flexDirection: 'column', height: '100vh'}}>
          <List style={{flexGrow: 1}}>
            <ListItem style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}} selected={location.pathname === '/dq_pro/home'} button onClick={()=>history.push('/dq_pro/home')}>
                <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                    <HomeIcon style={{color: '#F4F4F4'}}/>
                </ListItemIcon>
                {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Home" />}
            </ListItem>

              <div>
                  <ListItem
                      style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}}
                      selected={location.pathname.startsWith('/dq_pro/products') ||
                          location.pathname.startsWith('/dq_pro/assessment')}
                      button
                      onClick={() => {
                          setProductsMenuOpen(!productsMenuOpen);
                          history.push('/dq_pro/products');
                      }}
                  >
                      <ListItemIcon style={{display: 'block', minWidth: 'unset'}}>
                          <AssignmentIcon style={{color: '#F4F4F4'}}/>
                      </ListItemIcon>
                      {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Your Products" />}
                  </ListItem>

                  {/* Collapsible sub-items */}
                  {isDrawerOpen && productsMenuOpen && (
                      <List component="div" disablePadding>
                          <ListItem
                              style={{paddingLeft: '62px', justifyContent: 'flex-start'}}
                              selected={location.pathname === '/dq_pro/assessment/list'}
                              button
                              onClick={() => history.push('/dq_pro/assessment/list')}
                          >
                              <ListItemText primary="Assessments" />
                          </ListItem>
                          <ListItem
                              style={{paddingLeft: '62px', justifyContent: 'flex-start'}}
                              selected={location.pathname === '/dq_pro/learning/program/list'}
                              button
                              onClick={() => history.push('/dq_pro/learning/program/list')}
                          >
                              <ListItemText primary="Learning Program" />
                          </ListItem>
                          <ListItem
                              style={{paddingLeft: '62px', justifyContent: 'flex-start'}}
                              selected={location.pathname === '/dq_pro/alignment'}
                              button
                              onClick={() => history.push('/dq_pro/alignment')}
                          >
                              <ListItemText primary="Alignment" />
                          </ListItem>
                      </List>
                  )}
              </div>

              <ListItem style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}} selected={location.pathname === '/dq_pro/sales/resources'} button onClick={()=>history.push('/dq_pro/sales/resources')}>
                  <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                    <ImportContactsIcon style={{color: '#F4F4F4'}}/>
                </ListItemIcon>
                  {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Sales Resources" />}
            </ListItem>

            <ListItem style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}} selected={location.pathname === '/dq_pro/clients/list'} button onClick={()=>history.push('/dq_pro/clients/list')}>
                <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                    <GroupIcon style={{color: '#F4F4F4'}}/>
                </ListItemIcon>
                {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Client List" />}
            </ListItem>

            {/*<ListItem style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}} selected={location.pathname === '/dq_pro/sales-analytics'} button onClick={()=>history.push('/dq_pro/sales-analytics')}>*/}
            {/*    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>*/}
            {/*        <AttachMoneyIcon style={{color: '#F4F4F4'}}/>*/}
            {/*    </ListItemIcon>*/}
            {/*    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Sales Analytics" />}*/}
            {/*</ListItem>*/}

            {/*<ListItem style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}} selected={path === ''} button onClick={()=>history.push('')}>*/}
            {/*    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>*/}
            {/*        <TrendingUpIcon style={{color: '#F4F4F4'}}/>*/}
            {/*    </ListItemIcon>*/}
            {/*    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Impact Data" />}*/}
            {/*</ListItem>*/}

            {/*<ListItem style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}} selected={path === ''} button onClick={()=>history.push('')}>*/}
            {/*    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>*/}
            {/*        <AttachMoneyIcon style={{color: '#F4F4F4'}}/>*/}
            {/*    </ListItemIcon>*/}
            {/*    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Sales Analytics" />}*/}
            {/*</ListItem>*/}

        </List>
            <ListItem
                button
                onClick={handleUserMenuToggle}
                style={{
                    marginTop: 'auto',
                    padding: '0px !important',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    justifyContent: 'center'
                }}
            >
                <ListItemIcon style={{padding: '0px', display: 'block', minWidth: 'unset'}}>
                    <IconButton style={{padding: '0px', display: 'block',}} ref={anchorRefUserMenu}>
                        <Avatar
                            style={{color: 'white', backgroundColor: 'transparent', height: '55px', width: '55px',}}>
                            <AccountCircle style={{height: '35px', width: '35px',}}/>
                        </Avatar>
                    </IconButton>
                </ListItemIcon>
                {isDrawerOpen && <ListItemText
                    style={{ marginLeft: '5px' }}
                    primary={authUser?.email || 'User'}
                    primaryTypographyProps={{ style: { fontSize: '0.9rem' } }}
                />}
            </ListItem>
            <Menu
                anchorEl={anchorRefUserMenu.current}
                open={Boolean(openUserMenu)}
                onClose={handleUserMenuClose}
                anchorOrigin={{vertical: 'top', horizontal: 'left'}}
                transformOrigin={{vertical: 'bottom', horizontal: 'left'}}
                PaperProps={{
                    sx: {border: '1px solid #052F44', backgroundColor: 'F4EEEE'}
                }}
            >
                <MenuItem
                    disabled
                    style={{
                        color: '#ED6628',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        opacity: 1,
                    }}
                >
                    {authUser?.email || 'User Email'}
                </MenuItem>
                <Divider style={{ margin: '4px 0' }} />
                <MenuItem style={{color: '#ED6628'}} onClick={logoutAction}>Log out</MenuItem>
            </Menu>
        </div>
    );
}

export default withRouter(MainList);